// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np[data-v-02eff1d4] {\n  margin: 0;\n  font-weight: bold;\n  padding: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
